/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Customer_Invite_TitleInputs */



/**
* | output |
* | --- |
* | "Administrator has not signed in yet" |
*
* @param {Partner_Customer_Invite_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_invite_title = /** @type {((inputs?: Partner_Customer_Invite_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_Invite_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Administrator hat sich noch nicht angemeldet")
	return /** @type {LocalizedString} */ ("Administrator has not signed in yet")
});